import { useEffect, useState } from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import GrillaAvisosAnses from './GrillaAvisosAnses';
import { obtenerMisAvisos, guardarMisAvisos } from '../../services/avisosAnsesService';

const COLOR = '#2563eb';

/**
 * "Mis avisos de ANSES": qué novedades me avisan y por dónde. Solo llegan de lo que sigo: los
 * trámites con estrella en Para aprobar y los clientes con estrella en Seguimiento de Expedientes.
 */
export default function ModalMisAvisos({ open, onClose }) {
    const [preferencias, setPreferencias] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (!open) return;
        let vigente = true;
        setCargando(true);
        obtenerMisAvisos()
            .then((data) => { if (vigente) setPreferencias(Array.isArray(data) ? data : []); })
            .catch(() => toast.error('No se pudieron cargar tus avisos'))
            .finally(() => { if (vigente) setCargando(false); });
        return () => { vigente = false; };
    }, [open]);

    const guardar = async () => {
        setGuardando(true);
        try {
            setPreferencias(await guardarMisAvisos(preferencias));
            toast.success('Avisos guardados');
            onClose();
        } catch {
            toast.error('No se pudieron guardar tus avisos');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflowY: 'auto' } }}>
            <Box sx={{ background: `${COLOR}12`, borderBottom: `1px solid ${COLOR}33`, px: 3, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span className="fw-bold" style={{ color: '#1e293b', fontSize: '1.05rem' }}>
                    <i className="bi bi-bell me-2" style={{ color: COLOR }} />Mis avisos de ANSES
                </span>
                <IconButton onClick={onClose} size="small" aria-label="Cerrar"><CloseIcon fontSize="small" /></IconButton>
            </Box>
            <Box sx={{ p: 3 }}>
                <p style={{ fontSize: '0.85rem', color: '#4b5563' }}>
                    Te avisa solo de lo que seguís: los trámites con <i className="bi bi-star-fill" style={{ color: '#f59e0b' }} /> en
                    este listado y los clientes con estrella en Seguimiento de Expedientes. Los demás cambios de estado se ven en el
                    listado, sin aviso.
                </p>
                {cargando ? (
                    <p className="text-muted">Cargando…</p>
                ) : (
                    <GrillaAvisosAnses preferencias={preferencias} onChange={setPreferencias} idBase="mis-avisos" />
                )}
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>Cancelar</button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={guardar} disabled={guardando || cargando}>
                        {guardando ? 'Guardando…' : 'Guardar'}
                    </button>
                </div>
            </Box>
        </Dialog>
    );
}
